import React from 'react';
import styles from './About.module.css';

const About = () => {
  return (
    <section id="about" className={styles.about}>
      <div className={styles.container}>
        <div className={styles.aboutContent}>
          <div className={styles.aboutText}>
            <h2>Our Story</h2>
            <p>
              At Elite Cleaners, we’ve proudly served the Richmond community since 2009 — over 15 years of trusted dry cleaning, fold & wash, tailoring, and alterations. As a small, family-run business, we’re deeply committed to quality, personal service, and treating every garment with the utmost care.
            </p>
            <p>
              We recently moved just one block from our original location to better serve our loyal customers, but our dedication to excellence remains unchanged. Located in the heart of downtown Richmond, we specialize in keeping your wardrobe looking its best — whether you need meticulous dry cleaning, everyday laundry, or expert clothing repairs.
            </p>
            <p>
              Come visit us at our new location — we look forward to continuing to serve you with the same warmth and quality you’ve come to expect.
            </p>
          </div>
          <div className={styles.aboutImageContainer}>
            <img src="/images/pizza.png" alt="Delicious Pizza Fresca pizza" className={styles.aboutImage} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
